<template>
  <div class="flex column">
    <div
      v-if="forbidden" >
      <h1 class="settings__title">
        {{ business.name ? business.name : 'Number' }} WhatsApp Message Templates activity
      </h1>
      <Forbidden />
    </div>
    <div
      v-else
      class="settings--limit-width flex column">
      <h1 class="settings__title">
        {{ business.name ? business.name : 'Number' }} WhatsApp Message Templates activity
      </h1>

      <Spinner
        v-if="!initialMessageTemplateRequestFinished"
        class="mt-5"
        :size="20"
        :thickness="2" />

      <template v-else>
        <div class="actions-bar">
          <div
            class="flex">
            <SearchInput
              ref="searchInput"
              v-model="searchQuery"
              placeholder="Search Message Templates..."
              @input="searchTemplateMessages" />
            <!-- *************************************** -->
            <!-- Tag filtering -->
            <!-- *************************************** -->
            <!-- button -->
            <div class="sb2-wrapper mr-2 greedy">
              <button
                class="filter-button sb2-bordered sb2-hoverable sb2-focusable"
                @click="filterMenuToggle">
                <span class="filter-button-main-content">
                  <span class="sb2-icon filter size-12" />
                  Filter
                </span>
                <span
                  v-if="selectedFilters.length"
                  class="filter-button-filter-count">
                  {{ selectedFilters.length }}
                </span>
              </button>
              <!-- menu -->
              <div
                v-if="filterMenuIsOpen"
                v-click-outside="filterMenuClose"
                class="sb2-dropdown highlight-checked">
                <searchable-list
                  title="Filters"
                  :item-list="filterOptions"
                  :filter-fn="tagFilterSearchFn"
                  :clear-all-displayed="selectedFilters.length > 0"
                  @item-selected="selectFilter"
                  @clear-all="deselectFilter">
                  <template #default="slotProps">
                    <div
                      class="sb2-dropdown-item"
                      :class="{checked: selectedFilters.findIndex(filter => filter.value === slotProps.item.value) >= 0}">
                      <span
                        class="title-wrap ellipsis"
                        :inner-html.prop="slotProps.item.name | boldMatch(slotProps.searchTerm)" />
                      <SBIcon
                        v-if="selectedFilters.findIndex(filter => filter.value === slotProps.item.value) >= 0"
                        :icon="SBIconList.DONE_TICK"
                        :color="SBColors.bluePrimary"
                        :size="9" />
                    </div>
                  </template>
                </searchable-list>
              </div>
            </div>
          </div>
        </div>

        <div
          v-if="filtering"
          class="no-data" >
          <Spinner
            class="mt-5"
            :size="20"
            :thickness="2" />
        </div>
        <template v-else-if="sentTemplatesAppended.length > 0">
          <b-row class="data-wrapper greedy">
            <b-col
              class="m-0 p-0 templates__list"
              lg="6" >
              <ScrollArea
                ref="sentTemplatesScrollRef"
                @bottom="nextPage" >
                <!-- Template type shown -->
                <p
                  class="template__type" >
                  {{ filteredStatusesTitle }}
                </p>
                <div
                  v-for="(template, index) in sentTemplatesAppended"
                  :key="index" >
                  <!-- Log item -->
                  <div
                    class="template__item flex flex-align-center ellipsis"
                    :class="{active: template.id === selectedTemplateMessage.id}"
                    @click="selectTemplateMessage(template)" >
                    <span
                      class="template__status"
                      :class="getStatusColor(template.status)">{{ template.status }}</span>
                    <span
                      class="template__name"
                      :inner-html.prop="(template.template_message.name ? template.template_message.name : template.template_message.keyword) | boldMatch(searchQueryAfterDebounce)" />
                    <SBIcon
                      :icon="SBIconList.FULL_ARROW_RIGHT"
                      :size="10"
                      :color="SBColors.blackUltralight"
                      class="mx-2" />
                    <span
                      class="template__recipient ellipsis greedy"
                      :inner-html.prop="(`${template.contact.name} (${template.contact.phone})`) | boldMatch(searchQueryAfterDebounce)" />
                    <span class="template__date">{{ template.sent_at | timeFull }}</span>
                  </div>
                </div>
                <Spinner
                  v-if="page < meta.last_page || fetching"
                  class="mt-2"
                  :size="20"
                  :color="SBColors.blackPrimary"
                  :thickness="2"/>

              </ScrollArea>
            </b-col>
            <b-col
              class="template-data"
              lg="6" >
              <ScrollArea
                ref="templateDataRef"
                v-if="selectedTemplateMessage && selectedTemplateMessage.status" >
                <div class="bottom-20">
                  <div class="flex flex-align-center">
                    <h3 class="greedy"><strong>{{ selectedTemplateMessage.template_message.name ? selectedTemplateMessage.template_message.name : selectedTemplateMessage.template_message.keyword }}</strong></h3>
                  </div>

                  <div class="template-info">
                    <span class="template-info-title" >Status</span>
                    <span class="template-info-value" >
                      <span
                        class="template__status"
                        :class="getStatusColor(selectedTemplateMessage.status)">
                        {{ selectedTemplateMessage.status }}
                      </span>
                    </span>
                  </div>
                  <div class="template-info">
                    <span class="template-info-title" >Recipient</span>
                    <span class="template-info-value" >{{ selectedTemplateMessage.contact.name }} ({{ selectedTemplateMessage.contact.phone }})</span>
                  </div>
                  <!-- <div class="template-info">
                    <span class="template-info-title" >Keyword</span>
                    <span class="template-info-value" >{{ selectedTemplateMessage.template_message.keyword }}</span>
                  </div> -->
                  <div class="template-info">
                    <span class="template-info-title" >Language</span>
                    <span class="template-info-value" >{{ getLanguageName(selectedTemplateMessage.template_message.language, false) }}</span>
                  </div>
                  <div class="template-info">
                    <span class="template-info-title" >Time sent</span>
                    <span class="template-info-value" >{{ selectedTemplateMessage.sent_at | dateTimeFull }}</span>
                  </div>
                </div>

                <!-- Message text -->
                <div class="bottom-20">
                  <h5>Message</h5>

                  <!-- No user input is rendered here. -->
                  <!-- eslint-disable vue/no-v-html  -->
                  <div
                    class="template-message"
                    v-html="selectedTemplateMessage.template_message.text" />

                  <!-- Media message -->
                  <div
                    v-if="attachmentType"
                    class="media">
                    <img
                      v-if="attachmentType === 'image'"
                      :src="selectedTemplateMessage.template_message.attachment"
                      alt="attachment"
                      @load="reinitTemplateDataRef" >
                    <video
                      v-else-if="attachmentType === 'video'"
                      ref="videoImagePlaceholder"
                      class="video-image-preview"
                      controls
                      :src="selectedTemplateMessage.template_message.attachment"
                      :type="attachmentType">
                      Your browser does not support the video tag.
                    </video>
                    <SBAudioPlayer
                      v-else-if="attachmentType === 'audio'"
                      :type="attachmentType"
                      :url="selectedTemplateMessage.template_message.attachment" />
                    <a
                      v-else
                      class="flex flex-align-center"
                      :href="selectedTemplateMessage.template_message.attachment"
                      target="_blank" >
                      <SBIcon
                        :icon="SBIconList.DOWNLOAD"
                        :size="15"
                        :color="SBColors.blackPrimary"
                        class="mr-1" />
                      {{ getMediaName(selectedTemplateMessage.template_message.attachment) }}
                    </a>
                  </div>
                </div>
              </ScrollArea>
            </b-col>
          </b-row>
        </template>
        <div
          v-else
          class="no-data flex center-all" >
          <div class="flex center-all">
            <template v-if="searchQueryAfterDebounce && selectedFilters.length">
              <span class="wrapper flex center-all">
                <span class="emoji">😐</span>
                <p>We couldn’t find anything for <strong>{{ searchQueryAfterDebounce }}</strong> and selected statuses</p>
              </span>
            </template>
            <template v-else-if="searchQueryAfterDebounce">
              <span class="wrapper flex center-all">
                <span class="emoji">😐</span>
                <p>We couldn’t find anything for <strong>{{ searchQueryAfterDebounce }}</strong></p>
              </span>
            </template>
            <template v-else-if="selectedFilters.length">
              <span class="wrapper flex center-all">
                <span class="emoji">😐</span>
                <p>We couldn’t find anything for selected statuses</p>
              </span>
            </template>
            <template v-else>
              <span class="wrapper flex center-all">
                <span class="emoji">😐</span>
                <p>No data is available at the moment</p>
              </span>
            </template>
          </div>
        </div>
      </template>
      <MessageTemplateModal
        ref="messageTemplateModalRef"
        :business-id="business.id"
        @saved="fullReload()" />
    </div>
  </div>
</template>

<script>
import { debounce } from 'debounce';
import { mapActions, mapGetters } from 'vuex';

import { getMediaTypeFromExtension, getMediaName, getFileExtension } from '@/helpers/mediaHelpers';
import api from '@/helpers/api';
import ToasterMixin from '@/mixins/Toaster';
import SBIconList from '@/helpers/lists/sb-icon-list';
import SBColors from '@/helpers/lists/colors';
import SBIcon from '@/components/common/Icon';
import getLanguageName from '@/helpers/getLanguageName';
import { convertToTagView } from '@/helpers/stringHelpers';
import Spinner from '@/components/common/Spinner';
import ScrollArea from '@/components/common/ScrollArea';
import SearchInput from '@/components/business/widgets/SearchInput';
import MessageTemplateModal from '@/components/business/settings/modals/MessageTemplate.modal';
import SearchableList from '../../common/SearchableList';
import SBAudioPlayer from '@/components/common/AudioPlayer';
import NoPermissionMixin from '@/mixins/AccessPermission';

export default {
  name: 'MessageTemplates',
  components: {
    SBIcon,
    Spinner,
    ScrollArea,
    SearchInput,
    MessageTemplateModal,
    SearchableList,
    SBAudioPlayer,
  },
  mixins: [
    ToasterMixin,
    NoPermissionMixin,
  ],
  props: {
    business: {
      type: Object,
      required: false,
      default: () => {},
    },
  },
  data() {
    return {
      searchQueryAfterDebounce: '',
      whatsappPolicyUrl: 'https://www.whatsapp.com/legal/business-policy/',
      noTemplatesDescription: '',
      searchQuery: '',
      initialMessageTemplateRequestFinished: false,
      sentTemplatesAppended: [],
      selectedTemplateMessage: null,
      menuOpen: false,
      page: 1,
      limit: 3000,
      status: '',
      meta: {},
      fetching: false,
      filtering: false,
      selectedFilters: [],
      filterOptions: [
        {
          name: 'Sent',
          value: 'sent',
          order: 1,
        },
        {
          name: 'Delivered',
          value: 'delivered',
          order: 2,
        },
        {
          name: 'Read',
          value: 'read',
          order: 3,
        },
        {
          name: 'Failed',
          value: 'failed',
          order: 4,
        },
      ],
      filterMenuIsOpen: false,
      dateRange: {
        startDate: '',
        endDate: '',
      },
      SBIconList,
      SBColors,
    };
  },
  computed: {
    ...mapGetters({
      currentOrganisation: 'organisation/currentOrganisation',
    }),
    showView() {
      let view = 'initializing';
      if (this.initialMessageTemplateRequestFinished && Object.keys(this.templateMessageList).length) {
        view = 'templateList';
      } else if (this.initialMessageTemplateRequestFinished && !Object.keys(this.templateMessageList).length) {
        view = 'noTemplates';
      }
      return view;
    },
    filteredStatusesTitle() {
      let title = 'All';

      if (this.selectedFilters.length && this.selectedFilters.length < this.filterOptions.length) {
        title = '';
        [...this.selectedFilters].sort((a, b) => a.order - b.order).forEach((option, index) => {
          if (index === 0) {
            title += option.name;
          } else if (index + 1 === this.selectedFilters.length) {
            title += ` and ${option.name}`;
          } else {
            title += `, ${option.name}`;
          }
        });
      }

      return title;
    },
    // TODO this will probably go out since we do not have tags here
    selectedTemplateConvertedText() {
      return convertToTagView(this.selectedTemplateMessage.text);
    },
    attachmentType() {
      let type = null;

      if (this.selectedTemplateMessage.template_message.attachment) {
        type = getMediaTypeFromExtension(getFileExtension(this.selectedTemplateMessage.template_message.attachment));
      }

      return type;
    },
  },
  watch: {
    business() {
      this.searchQuery = null;
      this.searchQueryAfterDebounce = '';
      this.initialMessageTemplateRequestFinished = false;
      this.page = 1;
      this.sentTemplatesAppended = [];
      this.deselectFilter();
    },
  },
  mounted() {
    // in case user returns to the page. On first mount business is undefined so this will not trigger
    if (this.business.id) {
      this.fetchTemplateMessages(this.business.id);
    }
    this.finalizeSplashView();
  },
  methods: {
    ...mapActions({
      finalizeSplashView: 'organisation/finalizeSplashView',
    }),
    getLanguageName,
    getMediaName,
    fetchTemplateMessages() {
      this.fetching = true;
      const data = {
        limit: this.limit,
        page: this.page,
        status: this.selectedFilters.map(filter => filter.value).toString(),
        search_query: this.searchQuery,
        start_date: this.dateRange.startDate,
        end_date: this.dateRange.endDate,
      };
      api('GET', `organisation/${this.currentOrganisation.id}/business/${this.business.id}/whatsapp/template-message/sent`, data, null, 'w')
        .then((response) => {
          if (response.status === 200) {
            // TODO remove this after testing
            // this.sentTemplatesAppended.push({ "id": "c80be73d-87c2-4294-a0d8-bcab4acf551f", "status": "read", "sent_at": "2021-04-07 09:27:37", "meta_data": { "tags": { "1": "test vedran", "business_name": "Number" } }, "contact": { "id": "e2cb6adc-7d49-4744-9c1c-6c0c38b74994", "phone": "+385993037744", "name": "Ivan Ararrrr" }, "template_message": { "id": "ef4e5662-c614-46e7-8fa6-227ae6492e8a", "keyword": "image", "language": "en", "text": "Hi etyhtryj, how are you? How can we help you?", "attachment": "https://miro.medium.com/max/1838/1*MI686k5sDQrISBM6L8pf5A.jpeg" }, "bulk": null, "bulk_data": null, "bulk_res_data": {} });
            // this.sentTemplatesAppended.push({ "id": "c80be73d-87c2-4294-a0d8-bc3b4acf551f", "status": "read", "sent_at": "2021-04-07 09:27:37", "meta_data": { "tags": { "1": "test vedran", "business_name": "Number" } }, "contact": { "id": "e2cb6adc-7d49-4744-9c1c-6c0c38b74994", "phone": "+385993037744", "name": "Ivan Ararrrr" }, "template_message": { "id": "ef4e5662-c614-43e7-8fa6-227ae6492e8a", "keyword": "video", "language": "en", "text": "Hi etyhtryj, how are you? How can we help you?", "attachment": "https://www.learningcontainer.com/wp-content/uploads/2020/05/sample-mp4-file.mp4" }, "bulk": null, "bulk_data": null, "bulk_res_data": {} });
            // this.sentTemplatesAppended.push({ "id": "s80be73d-87c2-4294-a0d8-bc3b4acf551f", "status": "read", "sent_at": "2021-04-07 09:27:37", "meta_data": { "tags": { "1": "test vedran", "business_name": "Number" } }, "contact": { "id": "e2cb6adc-7d49-4744-9c1c-6c0c38b74994", "phone": "+385993037744", "name": "Ivan Ararrrr" }, "template_message": { "id": "ef4e5662-c614-43e7-8fa6-227ae6492e8a", "keyword": "audio", "language": "en", "text": "Hi etyhtryj, how are you? How can we help you?", "attachment": "https://file-examples-com.github.io/uploads/2017/11/file_example_MP3_700KB.mp3" }, "bulk": null, "bulk_data": null, "bulk_res_data": {} });
            // this.sentTemplatesAppended.push({ "id": "s80be73s-87c2-4294-a0d8-bc3b4acf551f", "status": "read", "sent_at": "2021-04-07 09:27:37", "meta_data": { "tags": { "1": "test vedran", "business_name": "Number" } }, "contact": { "id": "e2cb6adc-7d49-4744-9c1c-6c0c38b74994", "phone": "+385993037744", "name": "Ivan Ararrrr" }, "template_message": { "id": "ef4e5662-c614-43e7-8fa6-227ae6492e8a", "keyword": "doc", "language": "en", "text": "Hi etyhtryj, how are you? How can we help you?", "attachment": "https://www.learningcontainer.com/wp-content/uploads/2019/09/sample-pdf-download-10-mb.pdf" }, "bulk": null, "bulk_data": null, "bulk_res_data": {} });

            this.sentTemplatesAppended = [...this.sentTemplatesAppended, ...response.data.data];
            if (this.page === 1 && this.sentTemplatesAppended.length) {
              this.selectTemplateMessage(this.sentTemplatesAppended[0]);
            }
            this.meta = response.data.meta;

            // Hack for making sure the ref is available
            // It would be great if we can find a better solution
            const maxTime = 5000;
            let elapsedTime = 0;
            const step = 50;

            const interval = setInterval(() => {
              elapsedTime += step;
              if (this.$refs.sentTemplatesScrollRef) {
                this.loadMoreIfNeeded();
                clearInterval(interval);
              }
              if (elapsedTime > maxTime) {
                clearInterval(interval);
              }
            }, step);
            // Hack end
          }
        })
        .catch((error) => {

        }).finally(() => {
          this.initialMessageTemplateRequestFinished = true;
          this.filtering = false;
          this.fetching = false;
        });
    },
    loadMoreIfNeeded() {
      if (!this.$refs.sentTemplatesScrollRef.verticalScrollActive) {
        this.nextPage();
      }
    },
    nextPage() {
      if (this.page < this.meta.last_page) {
        this.page += 1;
        this.fetchTemplateMessages();
      }
    },
    selectTemplateMessage(templateMessage) {
      this.selectedTemplateMessage = templateMessage;
    },
    getStatusColor(status) {
      switch (status) {
        case 'delivered': {
          return 'delivered';
        }
        case 'read': {
          return 'read';
        }
        case 'failed': {
          return 'failed';
        }
        // will cover sent state or any other if needed
        default: {
          return 'gray';
        }
      }
    },
    filterMenuToggle() {
      this.filterMenuIsOpen = !this.filterMenuIsOpen;
    },
    filterMenuClose() {
      this.filterMenuIsOpen = false;
    },
    tagFilterSearchFn(searchTerm) {
      return item => item.name && item.name.toLowerCase().indexOf(searchTerm) !== -1;
    },
    selectFilter(option) {
      this.filtering = true;
      const optionIndex = this.selectedFilters.findIndex(selectedOption => option.value === selectedOption.value);
      if (optionIndex > -1) {
        this.selectedFilters.splice(optionIndex, 1);
      } else {
        this.selectedFilters.push(option);
      }
      this.page = 1;
      this.sentTemplatesAppended = [];
      this.fetchTemplateMessages(this.business.id);
    },
    deselectFilter() {
      this.filtering = true;
      this.selectedFilters = [];
      this.page = 1;
      this.sentTemplatesAppended = [];
      this.fetchTemplateMessages(this.business.id);
    },
    searchTemplateMessages: debounce(function f() {
      this.filtering = true;
      this.debounceActive = false;
      this.searchQueryAfterDebounce = this.searchQuery;
      this.sentTemplatesAppended = [];
      this.page = 1;
      this.fetchTemplateMessages(this.business.id);
    }, 500),
    reinitTemplateDataRef() {
      this.$refs.templateDataRef.isVerticalScrollActive();
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .bottom-20 {
  margin-bottom: 20px;
  border-bottom: 1px solid $greyBorderSecondary;
}

.actions-bar {
  margin-top: 35px;
  margin-bottom: 15px;
}


.data-wrapper {
  overflow: hidden;
  border-top: 1px solid $greyBorderSecondary;
}

.date-picker-wrapper {
  margin-top: 35px;
  margin-bottom: 15px;
}

.row {
  margin: 0 !important;
}

.template-data {
  height: 100%;
  overflow: auto;
  padding: 0 0 0 40px;

  .v-scroll-visible {
    padding-right: 40px;

    img {
      padding-bottom: 50px;
    }
  }

  h3 {
    margin: 20px 0 20px 0;
    font-size: 16px;
    font-weight: 400;
    color: $blackPrimary;
    cursor: default;

    strong {
      font-weight: 500;
    }
  }

  ::v-deep .settings-action {
    margin-right: 5px;
    border: none !important;
    background: none !important;
    box-shadow: none !important;
    padding: 0 !important;
    height: fit-content !important;

    &:active, &:focus, &:hover {
      border: none !important;
      background: none !important;
      outline: none !important;
      box-shadow: inherit !important;
    }

    .menu-button {
      background-image: url('~@/assets/img/SB-Icons/menu-3-dots-dark.svg');
      background-size: 16px 16px;
      width: 28px;
      height: 16px;
      border-radius: 5px;
      background-repeat: no-repeat;
      background-position: center;

      // menu button state when button is hovered or menu is open
      &:hover, &.active {
        box-shadow: 0 1px 3px 0 rgba(48, 54, 70, 0.3);
        border: solid 1px #cfd8dc;
        background-color: $white;
      }
    }
  }

  .template-info {
    cursor: default;
    min-height: 22px;
    display: flex;
    align-items: center;

    .template-info-title {
      font-size: 14px;
      font-weight: 400;
      color: $blackUltralight;
      margin-right: 8px;
    }

    .template-info-value {
      font-size: 14px;
      font-weight: 400;
      color: $blackPrimary;
    }

    .template__status {
      text-align: center;
      // min-width: 72px;
      font-size: 12px;
      font-weight: 500;
      border-radius: 3px;
      display: inline-block;
      text-transform: capitalize;

      &.read {
        padding: 3px 8px;
        color: $bluePrimary;
        background-color: $lightBackgroundBlue;
        border: 1px solid #d9e5f5;
      }

      // is changed to gray with stronger text color
      &.delivered {
        padding: 3px 8px;
        color: $blackPrimary;
        background-color: #edf0f2;
        border: 1px solid #e5e9eb;
      }

      &.gray {
        padding: 3px 8px;
        color: $blackUltralight;
        background-color: #edf0f2;
        border: 1px solid #e5e9eb;
      }

      &.failed {
        padding: 3px 8px;
        color: #ff5b61;
        background-color: #ffebec;
        border: 1px solid #f7e2e3;
      }
    }
  }

  h5 {
    font-size: 14px;
    font-weight: 500;
    color: $blackPrimary;
    margin: 0 0 15px 0;
  }

  .template-message, a, span {
    font-size: 14px;
    font-weight: 400;
    line-height: 1.37;
    color: $blackPrimary;
  }

  a {
    background: #edf0f2;
    padding: 5px 10px;
    border-radius: 5px;
  }

  .audio-player {
    border-radius: 5px;
    padding: 8px 12px;
  }

  .media span {
    font-weight: 500;
  }

  .media {
    margin: 20px 0 0 0;
    img, video {
      width: 100%;
      border-radius: 5px;
    }

    .audio-player {
      background: #edf0f2;
    }
  }
}

::v-deep .templates__list {
  height: 100%;
  overflow: auto;
  padding-right: 0px !important;
  border-right: 1px solid $greyBorderSecondary;

  .scroll-container {
    padding-top: 20px;
    padding-right: 40px;
    padding-bottom: 20px;
  }

  .template__type {
    font-size: 14px;
    font-weight: 500;
    margin-bottom: 12px;
  }

  .template__item {
    padding: 8px 10px;
    margin-bottom: 2px;
    border-radius: 5px;
    cursor: pointer;

    .template__status {
      text-align: center;
      min-width: 72px;
      font-size: 12px;
      font-weight: 500;
      border-radius: 3px;
      text-transform: capitalize;

      &.read {
        padding: 3px 8px;
        color: $bluePrimary;
        background-color: $lightBackgroundBlue;
        border: 1px solid #d9e5f5;
      }

      // is changed to gray with stronger text color
      &.delivered {
        padding: 3px 8px;
        color: $blackPrimary;
        background-color: #edf0f2;
        border: 1px solid #e5e9eb;
      }

      &.gray {
        padding: 3px 8px;
        color: $blackUltralight;
        background-color: #edf0f2;
        border: 1px solid #e5e9eb;
      }

      &.failed {
        padding: 3px 8px;
        color: #ff5b61;
        background-color: #ffebec;
        border: 1px solid #f7e2e3;
      }
    }

    .template__type {
      font-family: monospace;
      font-size: 14px;
      font-weight: 500;
      padding-left: 12px;
      padding-right: 10px;;
      color: $blackUltralight;
    }

    .template__name,
    .template__date,
    .template__recipient {
      font-size: 14px;
      font-weight: 400;
      color: $blackUltralight;
    }

    .template__name {
      padding-left: 12px;
    }

    .template__recipient {
      padding-right: 12px;
    }

    .template__url {
      font-family: monospace;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      margin-right: 15px;
    }

    &:hover {
      background-color: #fafbfc;
      .template__url,
      .template__date,
      .template__type,
      .template__name,
      .template__recipient {
        color: $blackPrimary;
      }

      .sb-icon .icon.mask {
        background-color: $blackPrimary !important;
      }
    }

    &.active {
      background-color: #f6f8f9;
      .template__url,
      .template__date,
      .template__type,
      .template__name,
      .template__recipient {
        color: $blackPrimary;
      }

      .sb-icon .icon.mask {
        background-color: $blackPrimary !important;
      }
    }
  }
}
</style>
